import { ElementType, FC, useMemo } from "react"
import { IconButton, IconButtonProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { getIcon } from "utils/icon"
import { MyLocationIcon } from "components/icons"

type MyLocationButtonProps = IconButtonProps & {
  component?: ElementType
  to?: string
}

export const MyLocationButton: FC<MyLocationButtonProps> = ({
  sx = {},
  ...props
}) => {
  const theme = useTheme()

  const { root, icon } =
    theme.components[`MyLocationButton`]?.styleOverrides || {}

  const locationIcon = useMemo(
    () =>
      getIcon(theme?.assets?.myLocationIcon, icon) || (
        <MyLocationIcon sx={icon} />
      ),
    [theme, icon]
  )

  return (
    <IconButton aria-label="location" sx={deepmerge(root, sx)} {...props}>
      {locationIcon}
    </IconButton>
  )
}
